import $ from 'jquery';
import { hideButtonLoader, showButtonLoader } from '../../../utils/button-loader';
import CartItemsCount from '../../shop-product/components/cart-items-count';
import GaTracking from '../../../core/components/ga-tracking';
import Toast from '../../../components/toasts';
import { ToastType } from '../../../types/toast';
export default class SingleProductAddToCart {
    static $button = $('.js__add-to-cart-ajax-btn');
    static init() {
        this.$button.on('click', event => {
            this.submitForm($(event.currentTarget));
        });
    }
    static submitForm($button) {
        showButtonLoader($button);
        this.pushAddToCartDataLayerEvent($button);
        $.ajax({
            type: 'POST',
            url: $button.data('url'),
            data: {
                [$button.data('color-input-name')]: $button.data('variant-code'),
                'sylius_add_to_cart[_token]': $button.data('token'),
            },
        }).then(({ quantity, content }) => {
            hideButtonLoader($button);
            CartItemsCount.set(quantity);
            const successUrl = $button.data('success-url');
            if (successUrl) {
                window.location.assign(successUrl);
            }
            else {
                Toast.callToast(ToastType.Success, '', $button.data('success-text'));
            }
        }, data => {
            const errors = data.responseJSON?.errors?.errors || [];
            if (errors.length) {
                Toast.callToast(ToastType.Error, errors[0].error, 'Error', { timeOut: 60000 });
            }
            else {
            }
            hideButtonLoader($button);
            GaTracking.pushDataLayer({
                event: 'popupDisplay',
                popupDisplayContent: 'Add to cart error',
            });
        });
    }
    static pushAddToCartDataLayerEvent($button) {
        const datalayer = $button.data('data-layer');
        if (datalayer) {
            GaTracking.pushDataLayer(datalayer);
        }
        GaTracking.pushDataLayer({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'EUR',
                add: {
                    products: [
                        {
                            name: $button.data('name'),
                            id: $button.data('layer-id'),
                            price: $button.data('price'),
                            brand: 'IQOS',
                            category: $button.data('category'),
                            variant: $button.data('label-en'),
                            quantity: 1,
                            dimension51: '4.1',
                            dimension52: 'In Stock',
                            dimension54: '',
                            dimension55: 'Standard',
                            metric11: $button.data('metric'),
                        },
                    ],
                },
            },
        });
    }
}
